import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=2eb5b0b4&"
import script from "./ScrollToTop.vue?vue&type=script&lang=ts&"
export * from "./ScrollToTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports